import { useSelector } from "react-redux";
import { desktopMarginsCutoff } from "../../../styleConstants";
import ButtonPanelMobile from "./ButtonPanelMobile/ButtonPanelMobile";
import ButtonPanelDesktop from "./ButtonPanelDesktop/ButtonPanelDesktop";

const HomeButtonPanel = () => {
  const screenWidth = useSelector((state) => state.screenWidth.value);

  // either return the mobile panel or desktop panel, depending on screen width
  let toReturn = <ButtonPanelMobile />;
  if (screenWidth >= desktopMarginsCutoff) {
    toReturn = <ButtonPanelDesktop />;
  }

  return toReturn;
};

export default HomeButtonPanel;
